// 페이지 lazy import 함수 + prefetch.
// router.tsx에서 분리해 컴포넌트 외 export로 인한 fast-refresh 경고를 피한다.
// lazy()와 prefetch가 같은 import 함수를 공유 → prefetch가 받아둔 청크를 진입 시 재사용.

export const importHome = () =>
  import("../pages/HomePage").then((m) => ({ default: m.HomePage }));
export const importMaterialList = () =>
  import("../pages/planner/MaterialListPage").then((m) => ({
    default: m.MaterialListPage,
  }));
export const importMaterialDetail = () =>
  import("../pages/planner/MaterialDetailPage").then((m) => ({
    default: m.MaterialDetailPage,
  }));
export const importReviewHub = () =>
  import("../pages/planner/ReviewHubPage").then((m) => ({
    default: m.ReviewHubPage,
  }));
export const importReviewSession = () =>
  import("../pages/planner/ReviewSessionPage").then((m) => ({
    default: m.ReviewSessionPage,
  }));
export const importPlannerCalendar = () =>
  import("../pages/planner/PlannerCalendarPage").then((m) => ({
    default: m.PlannerCalendarPage,
  }));
export const importIntegrations = () =>
  import("../pages/integrations/IntegrationsPage").then((m) => ({
    default: m.IntegrationsPage,
  }));
export const importRoutines = () =>
  import("../pages/planner/RoutinesPage").then((m) => ({
    default: m.RoutinesPage,
  }));
export const importWeeklyPlan = () =>
  import("../pages/planner/WeeklyPlanPage").then((m) => ({
    default: m.WeeklyPlanPage,
  }));
export const importNotes = () =>
  import("../pages/NotesPage").then((m) => ({ default: m.NotesPage }));
export const importLifelog = () =>
  import("../pages/LifelogPage").then((m) => ({ default: m.LifelogPage }));
export const importLifelogFlows = () =>
  import("../pages/LifelogFlowsPage").then((m) => ({
    default: m.LifelogFlowsPage,
  }));
export const importLifelogFlowDetail = () =>
  import("../pages/LifelogFlowDetailPage").then((m) => ({
    default: m.LifelogFlowDetailPage,
  }));
export const importWorkspaceSelect = () =>
  import("../pages/WorkspaceSelectPage").then((m) => ({
    default: m.WorkspaceSelectPage,
  }));
export const importTravelHome = () =>
  import("../pages/travel/TravelHomePage").then((m) => ({
    default: m.TravelHomePage,
  }));
export const importTripList = () =>
  import("../pages/travel/TripListPage").then((m) => ({
    default: m.TripListPage,
  }));
export const importTripForm = () =>
  import("../pages/travel/TripFormPage").then((m) => ({
    default: m.TripFormPage,
  }));
export const importTripBoard = () =>
  import("../pages/travel/TripBoardPage").then((m) => ({
    default: m.TripBoardPage,
  }));
export const importTripPrep = () =>
  import("../pages/travel/TripPrepPage").then((m) => ({
    default: m.TripPrepPage,
  }));
export const importTripExpenses = () =>
  import("../pages/travel/TripExpensesPage").then((m) => ({
    default: m.TripExpensesPage,
  }));
export const importTripPicker = () =>
  import("../pages/travel/TripPickerPage").then((m) => ({
    default: m.TripPickerPage,
  }));
export const importTravelTools = () =>
  import("../pages/travel/TravelToolsPage").then((m) => ({
    default: m.TravelToolsPage,
  }));
export const importTravelSettings = () =>
  import("../pages/travel/TravelSettingsPage").then((m) => ({
    default: m.TravelSettingsPage,
  }));
export const importTripMap = () =>
  import("../pages/travel/TripMapPage").then((m) => ({
    default: m.TripMapPage,
  }));
export const importPlaceSearch = () =>
  import("../pages/travel/PlaceSearchPage").then((m) => ({
    default: m.PlaceSearchPage,
  }));
export const importActivityDetail = () =>
  import("../pages/travel/ActivityDetailPage").then((m) => ({
    default: m.ActivityDetailPage,
  }));
export const importLinkList = () =>
  import("../pages/links/LinkListPage").then((m) => ({
    default: m.LinkListPage,
  }));
export const importLinkDetail = () =>
  import("../pages/links/LinkDetailPage").then((m) => ({
    default: m.LinkDetailPage,
  }));
/**
 * 로그인 후 idle 시간에 페이지 청크를 미리 받아둔다.
 * lazy로 초기 번들은 가볍게 유지하면서, 실제 진입 시에는 이미 캐시돼 즉시 렌더된다.
 */
export function prefetchRoutes() {
  // 테스트 환경에서는 prefetch를 건너뛴다. idle 콜백이 테스트 teardown 후
  // 동적 import를 실행해 EnvironmentTeardownError를 일으키기 때문.
  if (import.meta.env.MODE === "test") return;

  const run = () => {
    const ignore = () => {};
    void importMaterialDetail().catch(ignore);
    void importMaterialList().catch(ignore);
    void importReviewHub().catch(ignore);
    void importPlannerCalendar().catch(ignore);
    void importHome().catch(ignore);
    void importNotes().catch(ignore);
    // 로그인 직후 반드시 거치는 화면이라 가장 먼저 필요해진다.
    void importWorkspaceSelect().catch(ignore);
  };
  if (typeof requestIdleCallback === "function") {
    requestIdleCallback(run);
  } else {
    setTimeout(run, 1500);
  }
}
